module.exports = __webpack_public_path__ + "img/brand-justmad.de4afe57.svg";